import { Button } from 'blaze-ui/Button'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { Check2 } from 'blaze-ui/icons'
import { ReactComponent as SpecialOfferBanner } from 'assets/img/special-offer-50.svg'
import Styles from './StrategiesDiscount.module.scss'
import { Modal } from 'almanac-ui/Modal'

interface Props {
  onBack: () => void
  onContinueCancelling: () => void
  onAcceptOffer: () => void
  onClose: () => void
  isLoading: boolean
}

const benefits = [
  'Strategy-driven content built around your goals',
  'Advanced visuals that don’t look AI-generated',
  'Auto-generated carousel post',
  'Smarter chat-based editing',
]

export const StrategiesDiscount = ({ onBack, onContinueCancelling, onAcceptOffer, onClose, isLoading }: Props) => {
  return (
    <div className={Styles.container}>
      <Modal.Header title="Special offer" onClose={onClose} />
      <div className={Styles.content}>
        <Heading level={2} color="var(--dark-80)">
          Try NextGen Content before you go + get 50% off
        </Heading>
        <div className={Styles.heroBanner}>
          <SpecialOfferBanner className={Styles.bannerImage} />
        </div>
        <div className={Styles.benefits}>
          <Heading level={5}>
            Before you go, we’d love to invite you into early access for NextGen Content — our new, unreleased content
            experience built in a new workspace. <br />
            <br />
            It's a major upgrade to how Blaze creates content, with better quality, smarter strategy, and new features
            designed to fix the biggest reasons people leave. <br />
            <br />
            What's Different in NextGen workspace:
          </Heading>
          <ul className={Styles.benefitsList}>
            {benefits.map((benefit) => (
              <li key={benefit} className={Styles.benefitItem}>
                <span className={Styles.checkIcon}>
                  <Check2 size={14} color="white" />
                </span>
                <Text variant="primary" color="var(--dark-80)">
                  {benefit}
                </Text>
              </li>
            ))}
          </ul>
        </div>
        <div className={Styles.strategySession}>
          <Heading level={5}>Plus, get 50% off the first 2 months of your subscription.</Heading>
        </div>
      </div>
      <div className={Styles.divider} />
      <div className={Styles.footer}>
        <Button className={Styles.backButton} variant="tertiary" size="lg" onPress={onBack} isDisabled={isLoading}>
          Back
        </Button>
        <div className={Styles.buttonGroup}>
          <Button variant="tertiary" size="lg" onPress={onContinueCancelling} isDisabled={isLoading}>
            Continue Canceling
          </Button>
          <Button variant="primary" size="lg" onPress={onAcceptOffer} isDisabled={isLoading}>
            Try NextGen Content
          </Button>
        </div>
      </div>
    </div>
  )
}
